import { render, staticRenderFns } from "./ModalManageUnits.vue?vue&type=template&id=5285502d"
import script from "./ModalManageUnits.vue?vue&type=script&lang=js"
export * from "./ModalManageUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports